<div (click)="productDetails(element)">
  <div class="product-card" [class.product-card-mobile]="isMobile">
    @if(calcDis(element.pricea,element.pricec) !== 0){
    <div class="discount-badge">
      {{calcDis(element.is_daily_offer?element.affiliationprice:element.pricea,element.pricec)}}% {{ "discount" |
      transloco }}
    </div>
    } @if(
    element.is_daily_offer){
    <div class="daily-offer-badge">
      <span style="font-size: 10px;">
        @if(element.is_daily_offer){
        {{ "saveuptotext" | transloco }}
        }
      </span>
      <div class="chip-timer" [class.alert-error-text]="(dailyOfferState.progress$ | async)! <= 80">
        {{ dailyOfferState.timer$ | async }}
      </div>
    </div>

    }

    @if(element.image != null){
    <div class="col-12 product-img" [class.product-img-mobile]="isMobile">
      <img [defaultImage]="'/assets/imageloading.gif'" [lazyLoad]="bybrand?element.image:fixImage(element.image)"
        [errorImage]="'/assets/noproduct.png'" alt="product" />
    </div>
    } @else {
    <div class="col-12 product-img" [class.product-img-mobile]="isMobile">
      @if(element.pet == '0'){
      <img src="/assets/noproduct cat.webp">
      } @else {
      <img src="/assets/noproduct dog.png">
      }

    </div>
    }

    @if(isAr){
    <p class="product-name" [class.line-pc]="!isMobile" [class.line]="detectNumberofCharacters(element.name_ar)"
      [class.mt-3]="!isMobile" [class.product-name-mobile]="isMobile">
      {{element.name_ar}}
    </p>
    } @else {
    <p class="product-name" [class.line]="!isMobile" [class.line]="detectNumberofCharacters(element.name_en)"
      [class.mt-3]="!isMobile" [class.product-name-mobile]="isMobile">
      {{element.name_en}}
    </p>
    }


    <div class="d-flex justify-content-center align-items-center">
      <span class="new-price"
        [class.new-price-mobile]="isMobile">{{element.is_daily_offer?element.affiliationprice:element.pricea}} {{ "egpe"
        | transloco }}</span>
      @if(calcDis(element.is_daily_offer?element.affiliationprice:element.pricea,element.pricec) != 0){
      <span class="old-price" [class.new-price-mobile]="isMobile">{{element.pricec}} {{ "egpe" | transloco }}</span>
      }
    </div>

    <button class="btn btn-add" [class.alert-error]="
    element.is_daily_offer &&
    (dailyOfferState.progress$ | async)! <= 80
  " (click)="addToCart(element,element.quantity); $event.stopPropagation()">
      {{ "addtocart" | transloco }}
    </button>
  </div>
</div>
